module.exports = __webpack_public_path__ + "img/characterAnime25.3b634299.png";